import { useState, useEffect } from 'react';
import useFetch from '../../hooks/useFetch';
import useIsMobileView from "../../hooks/useIsMobileView";
import { Main, MainContent, Section, LoadingIcon, Button } from '@prosolve/common-components-ui'
import SoefiaMetricsView from './SoefiaMetricsView';
import SoefiaBackground from '../../images/soefia-assessment/bkg-metal.png';

export default () => {
  const urlParams = new URLSearchParams(window.location.search);
  const assessmentAnswerId = urlParams.get('assessmentAnswerId');
  const redirectOnCompleteUrl = urlParams.get('redirectOnCompleteUrl');
  const groupId = urlParams.get('groupId');

  const [answerData, setAnswerData] = useState({})
  const [loading, setLoading] = useState(true)

  const isMobileView = useIsMobileView();
  const fetch = useFetch();

  const getAssessmentAnswerData = async () => {
    try {
      setLoading(true)

      const response = await fetch(`assessment/answer?assessmentAnswerId=${assessmentAnswerId}`, { method: 'GET' })
      const jsonData = await response.json();

      const data = jsonData || {};

      if (data.error) {
        throw data.error
      }

      setAnswerData(data)
      setLoading(false)
    } catch (e) {
      console.log(e)
      setAnswerData({})
      setLoading(false)
    }
  }

  useEffect(() => {
    if (assessmentAnswerId) {
      getAssessmentAnswerData();
    } else {
      setAnswerData({})
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentAnswerId])

  const generateSoefiaMetrics = async (assessmentAnswersObj = {}, questionId) => {
    setLoading(true)
    const { _id: assessmentAnswerId = '' } = assessmentAnswersObj;
    const response = await fetch(`assessment/soefia/generateMetrics`, 
    { 
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ assessmentAnswerId, questionId })
    })

    await response.json();

    getAssessmentAnswerData()
  }

  const {
    needsSoefiaMetricsGeneration,
    soefiaMetricsGenerationInProgress,
    soefiaApiPayload,
    soefiaMetrics
  } = answerData;

  // last check here ensure existance, value of false for needsSoefiaMetricsGeneration still tells us we are of type Soefia
  const hasSoefiaMetrics = Boolean(soefiaMetrics) || ( 'needsSoefiaMetricsGeneration' in answerData)

  useEffect(() => {
    if (needsSoefiaMetricsGeneration && !soefiaMetricsGenerationInProgress) {
      generateSoefiaMetrics(answerData)

      // Timeout set to ensure the API call above is made
      setTimeout(() => {
        // Post message to parent to notify survey has been completed if Soefia type
        window.parent.postMessage(
          { type: "SURVEY_COMPLETE" },
          "*"
        );
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [needsSoefiaMetricsGeneration])

  if (hasSoefiaMetrics && Boolean(soefiaApiPayload)) {
    // console.log('Full ProSolve Answer Object:')
    // console.log(answerData)
    // console.log('----------')
    console.log('Payload Sent to Soefia to Generate Metrics:')
    console.log(soefiaApiPayload)
    console.log('----------')
  }

  useEffect(() => {
    const metricsLoading = (loading || needsSoefiaMetricsGeneration || soefiaMetricsGenerationInProgress)
    if (redirectOnCompleteUrl && groupId && !metricsLoading) {
      const fullSoefiaRedirectUrl = `${redirectOnCompleteUrl}?group_id=${groupId}`
      window.open(fullSoefiaRedirectUrl, '_self')
    } 
  })

  return (
    <Main $isMobileView={isMobileView} style={{
      color: '#c7ffff',
      backgroundImage: `url(${SoefiaBackground})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      fontFamily: '"Inter_24pt-Bold", "Open Sans", sans-serif'
    }}>
      <MainContent $isMobileView={isMobileView} style={{ maxWidth: '1200px' }}>
        <Section style={{ background: 'none' }}>
          {
            (loading || needsSoefiaMetricsGeneration || soefiaMetricsGenerationInProgress) || (redirectOnCompleteUrl && groupId)
              ?
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <LoadingIcon />
              </div>
              :
              hasSoefiaMetrics
              ?
              <div>
                <div 
                style={{ 
                  position: 'absolute',
                  top: '10px',
                  right: '10px'
                }}
                >
                  <Button
                    style={{ color: '#c7ffff', background: 'transparent' }}
                    $colored={true}
                    onClick={() => {
                      generateSoefiaMetrics(answerData)
                    }}
                  >
                    {'Regenerate Metrics'}
                  </Button>
                </div>
                <SoefiaMetricsView soefiaMetrics={soefiaMetrics} />
              </div>
              :
              <div>
                {'No metrics available to display.'}
              </div>
          }
        </Section>
      </MainContent>
    </Main>
  )
}